import { Link } from "react-router-dom";
import { MOCK_USERS } from "../lib/mockData";
import { MapPin, Edit, Shield, BarChart2, ChevronRight, ExternalLink } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useT } from "../lib/useLanguage";
import LogoSwap from "../components/LogoSwap";
import LanguageToggle from "../components/LanguageToggle";
import { motion } from "framer-motion";

export default function Profile() {
  const t = useT();
  const user = MOCK_USERS[0];

  return (
    <div className="max-w-lg mx-auto px-4 pt-4 pb-4">
      <div className="flex items-center justify-between mb-5">
        <LogoSwap size="sm" />
        <LanguageToggle />
      </div>

      {/* Profile card */}
      <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }}
        className="bg-card rounded-2xl border border-border overflow-hidden mb-4">
        <div className="h-1.5" style={{ background: "linear-gradient(to right, #FF6B4A, #B9F85A)" }} />
        <div className="p-5">
          <div className="flex items-start gap-4 mb-4">
            <img src={user.photo} alt="" className="h-16 w-16 rounded-2xl object-cover border-2 border-border" />
            <div className="flex-1">
              <h2 className="text-xl font-extrabold">{user.firstName}</h2>
              <p className="text-sm text-muted-foreground">{user.ageRange} ans · {user.status}</p>
              <p className="text-xs text-muted-foreground flex items-center gap-1 mt-0.5">
                <MapPin className="h-3 w-3" style={{ color: "#FF6B4A" }} />
                {user.zone} · {user.talenceLink}
              </p>
            </div>
            <Link to="/profile/edit">
              <Button size="sm" variant="outline" className="rounded-full text-xs gap-1">
                <Edit className="h-3 w-3" />{t("profile_edit")}
              </Button>
            </Link>
          </div>

          <p className="text-sm text-muted-foreground mb-4 leading-relaxed">{user.bio}</p>

          <div className="mb-3">
            <p className="text-xs font-bold text-foreground mb-2 uppercase tracking-wide">{t("profile_skills_offered")}</p>
            <div className="flex flex-wrap gap-1.5">
              {user.skillsOffered.map(s => (
                <span key={s} className="text-xs px-2.5 py-1 rounded-full font-medium"
                  style={{ backgroundColor: "#B9F85A30", color: "#4a7c2f", border: "1px solid #B9F85A" }}>{s}</span>
              ))}
            </div>
          </div>

          <div className="mb-3">
            <p className="text-xs font-bold text-foreground mb-2 uppercase tracking-wide">{t("profile_skills_needed")}</p>
            <div className="flex flex-wrap gap-1.5">
              {user.skillsNeeded.map(s => (
                <span key={s} className="text-xs px-2.5 py-1 rounded-full bg-muted text-muted-foreground font-medium">{s}</span>
              ))}
            </div>
          </div>

          <p className="text-xs text-muted-foreground">{t("profile_availability")} : {user.availability}</p>
        </div>
      </motion.div>

      {/* Stats teaser */}
      <div className="grid grid-cols-3 gap-2 mb-4">
        {[["3", "Offres"], ["2", "Demandes"], ["1", "Session"]].map(([n, l]) => (
          <div key={l} className="bg-card rounded-xl border border-border p-3 text-center">
            <p className="text-xl font-extrabold" style={{ color: "#FF6B4A" }}>{n}</p>
            <p className="text-xs text-muted-foreground">{l}</p>
          </div>
        ))}
      </div>

      {/* Quick links */}
      <div className="space-y-2">
        <Link to="/safety" className="flex items-center justify-between bg-card rounded-xl border border-border p-3.5 hover:bg-muted/30 transition">
          <span className="flex items-center gap-2 text-sm font-medium">
            <Shield className="h-4 w-4" style={{ color: "#FF6B4A" }} />{t("safety_title")}
          </span>
          <ChevronRight className="h-4 w-4 text-muted-foreground" />
        </Link>
        <Link to="/admin" className="flex items-center justify-between bg-card rounded-xl border border-border p-3.5 hover:bg-muted/30 transition">
          <span className="flex items-center gap-2 text-sm font-medium">
            <BarChart2 className="h-4 w-4" style={{ color: "#5B4BFF" }} />Admin (démo)
          </span>
          <ChevronRight className="h-4 w-4 text-muted-foreground" />
        </Link>
      </div>
    </div>
  );
}